import { InputHTMLAttributes } from "react";
import { Accordion, Alert, Form } from "react-bootstrap";
import { NoData, Spinner } from "@whitespace/whitespace-ui";
import IApplication from "interfaces/models/IApplication";

interface SitesFilterProps extends InputHTMLAttributes<HTMLInputElement> {
  register: any;
  accordionKey: string;
  hasFilterChanged : boolean;
  sites : string[];
  onSelectionChange : () => void;
}

const SitesFilter : React.FC<SitesFilterProps> = ({
  register, sites, accordionKey, hasFilterChanged, onSelectionChange
} : SitesFilterProps) => {
  const renderSites = () => {
    if (sites) {
      return sites.map((site : string) => (
        <Form.Check
          {...register("sites")}
          key={`site_${site}`}
          id={`site_${site}`}
          data-testid={`site_${site}`}
          name="sites"
          type="checkbox"
          label={`${site}`}
          value={site}
          className="left-margin-medium"
          onInput={onSelectionChange}
        />
      ));
    }
    return undefined;
  };

  return (
    <>
      <Accordion key={accordionKey} defaultActiveKey={hasFilterChanged ? "accordionApplications" : ""}>
        <Accordion.Item eventKey="accordionApplications">
          <Accordion.Header data-testid="siteHeader">
            Site
            <Spinner className="left-margin-small" animation="grow" visible={false} spinnerText="Loading" variant="info" />
          </Accordion.Header>
          <Accordion.Body>
            <section>
              <Form.Group controlId="applications">
                {sites && sites.length > 0 && renderSites()}
                <NoData visible={!(sites && sites.length > 0)} description="No Sites found." />
              </Form.Group>
            </section>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
};

export default SitesFilter;
